import z from "zod";
import link from "../objects/link.js";
var fragment = {
    type: "array",
    of: [
        {
            type: "block",
            lists: [],
            styles: [],
            marks: {
                annotations: [
                    link.schema.object
                ],
                decorators: [
                    {
                        title: "Bold",
                        value: "strong"
                    },
                    {
                        title: "Italic",
                        value: "em"
                    }
                ]
            }
        }
    ]
};
var validator = z.array(z.unknown()).refine(function(value) {
    return true;
});
export default {
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=simpleBlockContent.js.map